<template>
    <div class="about" :class="{'shadowed': shadow}">
        <Icon class="about__icon" :icon="icon"/>
        <p class="about__text">{{title}}</p>
        <p class="about__text about__text-value">
            <span v-if="currency">{{value}}</span>
            {{ value | kFormatter(value)}}
        </p>
    </div>
</template>

<script>
import Icon from '@/components/Theme/Icon'
import { kFormatter } from '../../core/filters'
export default {
    name: 'About',
    components: {
        Icon
    },
    props: {
        icon: {
            type: String,
            default: () => ''
        },
        title: {
            type: String,
            default: () => ''
        },
        value: { 
            type: [String, Number],
            default: () => ''
        },
        shadow: {
            type: Boolean,
            default: () => false
        },
        currency: {
            type: Boolean,
            default: () => false
        }
    },
    filters: {
        kFormatter
    }
}
</script>

<style lang="scss" scoped>
$radius: 8px;
$border: 1px solid #E2E8F0;
$padding: 12px 20px;
$fontsize: 14px;
$lineheight: 24px;
$color: #333333;
$shadow: 0px 8px 24px -6px rgba(113, 128, 150, 0.16), 0px 0px 1px rgba(113, 128, 150, 0.2); 
.about {
    padding: $padding;
    border-radius: $radius;
    border: $border;
    display: flex;
    align-items: center;
    margin-bottom: 16px;
    &.shadowed {
        box-shadow: $shadow;
    }
    &__text {
        font-size: $fontsize;
        line-height: $lineheight;
        color: $color;
        margin-bottom: 0;
        margin-right: 8px;
        &-value {
            font-weight: bold;
        }
    }
    &__icon {
        margin-right: 16px;
    }
}
</style>>
